import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  TimePicker,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import dayjs from "dayjs";
import moment from "moment";
import { timePart } from "../../../../utils";

const { TextArea } = Input;
const format = "HH:mm";
const AddShiftTypeModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { itemb, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const [startTime, setStartTime] = useState(
    formData?.stStartTime ? moment(formData?.stStartTime, "HH:mm:ss") : null
  );
  const [endTime, setEndTime] = useState(
    formData?.stEndTime ? moment(formData?.stEndTime, "HH:mm:ss") : null
  );

  const handleStartTimeChange = (time) => {
    setStartTime(time);
  };
  const handleEndTimeChange = (time) => {
    setEndTime(time);
  };

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }
 
  const onFinish = async (data) => { 
    data.stStartTime = timePart(data?.stStartTime?.$d);
    data.stEndTime = timePart(data?.stEndTime?.$d);
    data.stId = prodd?.stId ?? null;
    const res = await dispatch(
      save({
        ...data, 

        url: "shift/saveShitType.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => { 
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
        stStartTime: prodd?.stStartTime ? dayjs(prodd?.stStartTime, "HH:mm:ss") : null,
        stEndTime: prodd?.stEndTime ? dayjs(prodd?.stEndTime, "HH:mm:ss") : null,
      });
    } else {
      form.setFieldsValue({
        stStartTime: null, 
        stEndTime: null,  
        stName: "", 
        stDescription: "",
      });
    }
  }, [prodd, form]);

  const initialValues = {
    ...prodd,
    stStartTime: prodd?.stStartTime ? dayjs(prodd?.stStartTime, "HH:mm:ss") : null,
    stEndTime: prodd?.stEndTime ? dayjs(prodd?.stEndTime, "HH:mm:ss") : null,
  };
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.stName}` : "Add shift type details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          initialValues={initialValues}
        >
          <Form.Item
            name="stName"
            label="Shift Name"
            rules={[
              {
                required: true,
                message: "Enter Shift Name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="stStartTime"
            rules={[
              {
                required: false,
                message: "Start time field is required",
              },
            ]}
            label="Start time"
          >
            <TimePicker
              required
              style={{
                width: "100%",
                height: "44px",
              }}
              format={format}
              className="input"
            />
          </Form.Item>

          <Form.Item
            name="stEndTime"
            rules={[
              {
                required: false,
                message: "End time field is required",
              },
            ]}
            label="End time"
          >
            <TimePicker
              style={{
                width: "100%",
                height: "44px",
              }}
              format={format}
              className="input"
            />
          </Form.Item>

          <Form.Item
            name="stDescription"
            label="Shift Description"
            rules={[
              {
                required: true,
                message: "Enter Shift Description",
              },
            ]}
          >
            <TextArea required rows={6} className="input" />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddShiftTypeModal;
